import $ from 'jquery';

var assignmentClass;

export default class Activity {
  constructor() {
    let that = this;

    /**
    * @name activity-show
    * @function
    * @param {config}
    * @description: Event listener for show activity
    */
    $(document).bind('activity-show', function (e, config) {
      $('.activity-section-container').removeClass('hide').addClass('show');
      $('.activity-section-container').removeClass(assignmentClass).addClass(config.assignmentClass);
      $('.activity-section-content').removeClass(assignmentClass).addClass(config.assignmentClass);
      assignmentClass = config.assignmentClass;
      config.callback();
    }).bind(that);

    /**
    * @name activity-hide
    * @function
    * @param {config}
    * @description: Event listener for hide activity
    */
    $(document).bind('activity-hide', function (e, config) {
      $('.activity-section-container').removeClass('show').addClass('hide');
    }).bind(that);
  }

}


// WEBPACK FOOTER //
// ./src/components/activity.js